import { Component, DestroyRef, inject } from '@angular/core';
import { InstallationStateService } from '../../../services/installation.state.service';
import { Installation } from '../../../../../../models/configurators-2d/applications/fence/installations/installation';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { tap } from 'rxjs';
import { logError } from '../../../../../../services/helpers/sentry.helper';
import { MaterialsFacadeService } from '../../services/materials.facade.service';
import { MaterialSubStepService } from '../../services/material-sub-step.service';
import { FenceService } from '../../../../../../services/configurators-2d/applications/fence.service';
import { SubStepEnum } from '../../models/sub-step.enum';

@Component({
  selector: 'ng-casto-materials-installation-simples',
  templateUrl: './materials-installation-simples.component.html',
  styleUrl: './materials-installation-simples.component.scss',
})
export class MaterialsInstallationSimplesComponent {
  private readonly installationStateService = inject(InstallationStateService);
  private readonly materialsFacadeService = inject(MaterialsFacadeService);
  private readonly materialSubStepService = inject(MaterialSubStepService);
  private readonly fenceService = inject(FenceService);
  private readonly destroyRef = inject(DestroyRef);

  baseImgURL: string = undefined;

  /**
   * Retourne la liste des poses disponibles
   * @protected
   */
  protected get installations(): Installation[] {
    return this.installationStateService.installations();
  }

  constructor() {
    this.baseImgURL = this.fenceService.apiUrl;
  }

  /**
   * Est-ce que l'installation est sélectionnée ?
   * @param installation
   * @protected
   */
  protected isInstallationSelected(installation: Installation): boolean {
    return this.materialsFacadeService.isInstallationSelected(installation);
  }

  protected selectInstallation(installation: Installation): void {
    this.materialsFacadeService
      .selectInstallation(installation)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        tap(() => this.materialSubStepService.toggleCollapse(SubStepEnum.Boards))
      )
      .subscribe({
        error: err => logError('Erreur sélection pose:', err),
      });
  }
}
